import axios from "axios";
import { api_url, PLATFORM } from "../../config";
import tools from "../../helpers/tools";
import { CONSTANT_TYPES } from "../reducers/constantReducers";

export const constantActions = (state, dispatch, props) => {
  function getConstants() {
    dispatch({ type: CONSTANT_TYPES.LOAD_CONSTANT, payload: true });

    axios
      .get(`${api_url}constants/${PLATFORM}`)
      .then((res) => {
        dispatch({ type: CONSTANT_TYPES.GET_CONSTANTS, payload: res.data });
      })
      .catch((err) => {
        var err = tools.filterError(err, dispatch, CONSTANT_TYPES.LOAD_CONSTANT);
      });
  }

  return {
    getConstants,
  };
};
